import {
  loginRoute,
  changePasswordRoute,
  editProfileRoute,
  statusDashboardRoute,
  servicesAdministrationRoute,
  incidentsAdministrationRoute,
  popupsAdministrationRoute,
  serviceClientsAdministrationRoute
} from './../../core/routing/route-names';
import { Component, ViewChild, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLinkActive, RouterLink } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { UserInfoDTO } from '../models/models.swagger.generated';
import { Observable, filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ItemModel, DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { AccordionComponent, AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { ModalService } from '../shared/modal/modal.service';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { NgClass } from '@angular/common';

interface RouteIdentifier {
  route: string;
  id: string;
}

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [NgClass, LanguageSelectorComponent, TranslateModule, DropDownButtonModule, AccordionModule, RouterLink, RouterLinkActive]
})
export class NavigationComponent implements OnInit {
  public loading = false;
  public userInfoModels: UserInfoDTO[] = [];
  public userInfoModels$: Observable<UserInfoDTO[]>;

  public loginRoute = loginRoute;
  public statusDashboardRoute = statusDashboardRoute;
  public servicesAdministrationRoute = servicesAdministrationRoute;
  public incidentsAdministrationRoute = incidentsAdministrationRoute;
  public popupsAdministrationRoute = popupsAdministrationRoute;
  public serviceClientsAdministrationRoute = serviceClientsAdministrationRoute;

  public adminSectionId = 'admin-section';

  private subrouteMatch: RouteIdentifier = null;

  @ViewChild(AccordionComponent) public accordion: AccordionComponent;

  public userIcon = 'icon-user';
  public userNavigation: ItemModel[] = [];

  private isAccordionInitialized = false;

  public envInfo: string | null = null;

  constructor(
    private router: Router,
    private modalService: ModalService,
    private translate: TranslateService,
    public authService: AuthService) {
  }

  public ngOnInit(): void {
    this.setUserNavigationPoints();
    this.translate.onLangChange.subscribe(_ => {
      this.setUserNavigationPoints();
    });
    this.envInfo = environment.envInfoClass?.length > 0 ? environment.envInfoClass : null;

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      const subroutes: RouteIdentifier[] = [
        { route: '/services-administration', id: this.adminSectionId },
        { route: '/incidents-administration', id: this.adminSectionId },
        { route: '/popups-administration', id: this.adminSectionId },
        { route: '/service-clients-administration', id: this.adminSectionId },
      ];
      const url = (this.router.url + '/').toLocaleLowerCase();
      this.subrouteMatch = subroutes.find(s => url.indexOf(s.route) > -1) ?? null;

      if (this.isAccordionInitialized) {
        this.expandAccordionSection(this.subrouteMatch?.id);
      }
    });
  }

  public onSelection(event: any): void {
    switch (event.item.id) {
      case 'editProfile':
        this.editUser();
        break;
      case 'changePassword':
        this.changePassword();
        break;
      case 'logout':
        this.logout();
        break;
    }
  }

  public editUser() {
    this.router.navigate([editProfileRoute]);
  }

  public logout() {
    const dialog = this.modalService.showOkCancelDialog('i18n.core.modal.logout.title', 'i18n.core.modal.logout.question');
    dialog.onOkSubject.subscribe(() => {
      this.router.navigate([loginRoute], { queryParams: { init: 'true' } })
        .then(() => { this.authService.logout(); });
    });
  }

  public changePassword() {
    this.router.navigate([changePasswordRoute]);
  }

  public onAccordionCreated() {
    this.isAccordionInitialized = true;
    if (this.subrouteMatch) {
      this.expandAccordionSection(this.subrouteMatch.id);
    }
  }

  private expandAccordionSection(htmlElementId: string | undefined) {
    if (!this.accordion) return;
    for (let i = 0; i < this.accordion.element.children.length; i++) {
      const item = this.accordion.element.children.item(i);
      if (item.id === htmlElementId) {
        this.accordion.expandItem(true, i);
      } else {
        this.accordion.expandItem(false, i);
      }
    }
  }

  private setUserNavigationPoints() {
    this.userNavigation = [
      { text: this.translate.instant('i18n.core.navigation.editProfile'), id: 'editProfile', iconCss: 'icon-user--profile' },
      { text: this.translate.instant('i18n.core.navigation.changePassword'), id: 'changePassword', iconCss: 'icon-password' },
      { text: this.translate.instant('i18n.core.navigation.logout'), id: 'logout', iconCss: 'icon-logout' },
    ];
  }
}
